import { Ethnicities } from "../Data/Ethnicities";

export function getEthnicityFromRand(rand: number) {
    return Ethnicities[
        Math.min(
            Math.abs(
                Math.floor(
                    Ethnicities.length * Math.abs(rand)
                )
            ),
            Ethnicities.length - 1
        )
    ];
}